import { render, staticRenderFns } from "./AccountNew.vue?vue&type=template&id=c524aedc&scoped=true"
import script from "./AccountNew.vue?vue&type=script&lang=js"
export * from "./AccountNew.vue?vue&type=script&lang=js"
import style0 from "./AccountNew.vue?vue&type=style&index=0&id=c524aedc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c524aedc",
  null
  
)

export default component.exports